// extracted by mini-css-extract-plugin
export var calculated = "styles-module--calculated--ec1fe";
export var highlightedText = "styles-module--highlightedText--30246";
export var lb = "styles-module--lb--3b024";
export var lt = "styles-module--lt--97693";
export var rb = "styles-module--rb--609a4";
export var rt = "styles-module--rt--b3865";
export var tooltip = "styles-module--tooltip--509ab";
export var tooltipBody = "styles-module--tooltipBody--8abd8";
export var tooltipHeader = "styles-module--tooltipHeader--25483";